export default "__VITE_ASSET__oJ1KM0tJ__"